<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="标题" prop="name">
                <el-input v-model="viewData.name" />
            </el-form-item>
            <el-form-item label="图标">
                <image-upload ref="imageUpload"
                          v-if="showUpload"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸50*50,请自己处理好宽高比例`"
                          :image-list="imageDefaultList"
                          autoCropWidth="50"
                          autoCropHeight="50"
                          :maxNumber="1"
                          @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="分类">
                <el-select
                        v-model="viewData.fenlei_id"
                        clearable
                        filterable
                        placeholder="请选择分类"
                >
                <el-option v-for="item in optionCate"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="小区" prop="commId">
                <el-cascader :options="options" :props="props" v-model="caasaderarr" collapse-tags clearable></el-cascader>
            </el-form-item>    

            <el-form-item label="跳转类型">
                <el-select v-model="viewData.tiaozhuantype" clearable filterable placeholder="请选择跳转类型">
                    <el-option v-for="item in tiaozhuantypeList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="小程序AppID" v-if="viewData.tiaozhuantype==3">
                <el-input v-model="viewData.tiaozhuanappid" />
            </el-form-item>
            <el-form-item label="页面路径" v-if="viewData.tiaozhuantype==2||viewData.tiaozhuantype==3">
                <el-input v-model="viewData.tiaozhuanurl" />
            </el-form-item>
            <el-form-item label="跳转是否需要登录" v-if="viewData.tiaozhuantype==2||viewData.tiaozhuantype==3">
                <el-switch
                    v-model="viewData.is_denglu"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="跳转是否需要业主" v-if="viewData.tiaozhuantype==2||viewData.tiaozhuantype==3">
                <el-switch
                    v-model="viewData.is_yezhu"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            
            <el-form-item label="弹框图片" v-if="viewData.tiaozhuantype==4">
                <image-upload ref="imageUpload1"
                          v-if="showUpload1"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸330*330,请自己处理好宽高比例`"
                          :image-list="imageDefaultList1"
                          :maxNumber="1"
                          @updateImg="onUpdateImg1($event)"></image-upload>
            </el-form-item>
            
            <el-form-item label="排序">
                <el-input-number size="mini" style="width: 100px" v-model="viewData.sort" controls-position="right"
                    :min="0"></el-input-number>
            </el-form-item>
            
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
        
       
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/bianmin";
import bianminfenlei from "@/api/tianzheng/bianminfenlei";
import dylbanner from "@/api/tianzheng/dylbanner";
import Qu from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination

export default {
    data() {
        return {
            thumbList: [],
            thumbList1: [],
            imageDefaultList: "",
            imageDefaultList1: "",
            showUpload:false,
            showUpload1:false,
            optionCate: [],
            optionList: [],
            caasaderarr:[],
            props: { multiple: true },
            tiaozhuantypeList:[{id:1,name:'不跳转'},{id:2,name:'跳转业主小程序'},{id:3,name:'跳转其他小程序'},{id:4,name:'弹框'}],
            options: [],
            viewData: {
                id:'',
                fenlei_id:'',
                name: "",
                commId: "0",
                show_type: "",
                tiaozhuantype: 1,
                content: "",
                source: "",
                publish_at: "",
                end_at: "",
                sort: 0,
                is_top: 1,
                is_denglu: 0,
                is_yezhu: 0,
                status: 1,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                show_type:[
                {
                        required: true,
                        message: "请选择显示类型",
                        trigger: "blur",
                    },
                ]
            },
        };
    },
    components: {
        Pagination,
        ImageUpload,
        
    },
    created() {
        this.getSelectCity()
        this.getSelectCate()
    },
    methods: {
        onUpdateImg (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        onUpdateImg1 (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList1 = thumbList;
        },
        // 获取下拉列表
        getSelectCate () {
            bianminfenlei.select({}).then(res => {
                if (res.code == 200) {
                this.optionCate = res.result;
                this.optionCate.unshift({
                    id:0,
                    name:'请选择分类'
                })
                }
            });
            dylbanner.select({}).then(res => {
                if (res.code == 200) {
                    this.options = res.result;
                }
            })
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            this.resetForm()
            let that = this
            this.caasaderarr = [],
            this.viewData = {
                id:'',
                fenlei_id:0,
                name: "",
                commId: "0",
                caarr: [],
                show_type: "",
                content: "",
                source: "",
                publish_at: this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
                end_at: "",
                sort: 0,
                is_denglu: 0,
                is_yezhu: 0,
                is_top: 1,
                status: 1,
                tiaozhuantype: 1,
            }
            this.showUpload = true;
            this.showUpload1 = true;
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        that.caasaderarr = res.result.caarr
                        let imgList = [];
                        let thumb_arr = [that.viewData.thumb];
                        thumb_arr.forEach((ele, index) => {
                            let obj = {
                                name: ele,
                                path: ele,
                                url: that.$publicData.imgUrl + ele,
                            }
                            imgList.push(obj);
                        })
                        // 回显图
                        that.imageDefaultList = JSON.stringify(imgList);
                        if(that.viewData.tiaozhuantype == 4){
                            setTimeout(() => {
                                console.log("存在跳转图片",that.viewData.thumb_tiaozhuan);
                                let imgList1 = [];
                                imgList1.push({
                                    name: that.viewData.thumb_tiaozhuan,
                                    path: that.viewData.thumb_tiaozhuan,
                                    url: that.$publicData.imgUrl + that.viewData.thumb_tiaozhuan,
                                });
                                // 回显图
                                that.imageDefaultList1 = JSON.stringify(imgList1);
                            }, 100);
                        }
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
          
            let that = this;
            if(this.thumbList.length<1){
                this.$message.warning("请上传图标")
                return
            }
            this.viewData.thumb = this.thumbList[0];
            if(this.viewData.tiaozhuantype == 4){
                if(this.thumbList1.length<1){
                    this.$message.warning("请上传弹框图片")
                    return;
                }
                this.viewData.thumb_tiaozhuan = this.thumbList1[0];
            }
            this.viewData.caarr = this.caasaderarr;
            let count = 0
            for (let i = 0; i < this.options.length; i++) {
                const item = this.options[i];
                for (let j = 0; j < item.children.length; j++) {
                    const subItem = item.children[j];
                    for (let n = 0; n < subItem.children.length; n++) {
                        count ++;
                    }
                }
            }
            let is_jituan = 0
            if (this.caasaderarr.length >= count) {
                is_jituan = 1
            }  
            this.viewData.is_jituan = is_jituan;
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(that.viewData.id){
						// 编辑
						fetch.edit(that.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(that.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.thumbList = [];
            this.thumbList1 = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.imageDefaultList1 = "";
             if (this.$refs.imageUpload1) {
                this.$refs.imageUpload1.clearFileList();
            }
            this.$refs["ruleForm"].resetFields();
            this.showUpload = false;
            this.viewData.publish_at = this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
        },
        formatDate (tt, fmt) {
            if (null == tt || "" == tt) return "";
                var date = new Date(tt);
                let o = {
                    "M+": date.getMonth() + 1, // 月份
                    "d+": date.getDate(), // 日
                    "h+": date.getHours(), // 小时
                    "m+": date.getMinutes(), // 分
                    "s+": date.getSeconds(), // 秒
                    S: date.getMilliseconds() // 毫秒
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(
                    RegExp.$1,
                    (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                }
                for (var k in o) {
                    if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length === 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length)
                    );
                }
             }
            return fmt;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
